var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BaseApi from '~/api/base';
import ApiError from '~/errors/api';
import { keysToCamel } from '~/utils/toCamelCase';
class PolicyAnalysisUpload extends BaseApi {
    constructor() {
        super('/policy-analysis-upload');
    }
    post(payload_1) {
        return __awaiter(this, arguments, void 0, function* (payload, redirectToErrorPage = true) {
            if (this.useMock) {
                return {
                    presignedUrl: 'mockPresignedUrl',
                    file: {
                        id: '1234567890',
                    },
                };
            }
            let response;
            try {
                response = yield fetch(this.url, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        metadata: payload.metadata,
                        organization_id: BaseApi.organizationId,
                    }),
                });
            }
            catch (error) {
                if (redirectToErrorPage) {
                    const apiError = new ApiError(`Failed to POST to '${this.route}': ${error.message}`);
                    const info = JSON.stringify({ payload });
                    window.routeToErrorPage(apiError, info);
                }
            }
            if (response && response.status === 200) {
                const res = yield response.json();
                return keysToCamel(res);
            }
        });
    }
    update(fileId, payload) {
        return super.update(fileId, payload);
    }
}
const PolicyAnalysisUploadApi = new PolicyAnalysisUpload();
export default PolicyAnalysisUploadApi;
